'use client';

import { c as _c } from "react/compiler-runtime";
import { defaultStyles, FileIcon as ReactFileIcon } from 'react-file-icon';
import { getFileExtension } from '@/lib/utils';
import { FileType } from '@/types/file';
type PropsType = {
  file: FileType;
};
const ContentFileIcon = t0 => {
  const $ = _c(7);
  const {
    file
  } = t0;
  let t1;
  if ($[0] !== file.path) {
    t1 = getFileExtension(file.path);
    $[0] = file.path;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== file.path) {
    t2 = defaultStyles[getFileExtension(file.path) as keyof typeof defaultStyles] || {};
    $[2] = file.path;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <ReactFileIcon extension={t1} {...t2} />;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default ContentFileIcon;